import React, { useState } from 'react'
import Input from './Input'
import ButtonWithLoader from './ButtonWithLoader'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { SET_SHOW_RESET_PASSWORD_EMAIL_MODAL, SEND_RESET_PASSWORD_EMAIL } from '../redux/authReducer'
import EmailSentModal from './EmailSentModal'
import { Link } from 'react-router-dom'

type Props = {}

const ResetPasswordScreen = (props: Props) => {
  const isLoading = useSelector((state: RootReducer) => state.authReducer.isLoading)
  const showResetPasswordEmailModal = useSelector((state: RootReducer) => state.authReducer.showResetPasswordEmailModal)
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const submitError = useSelector((state: RootReducer) => state.authReducer.submitError)

  return (
    <div className="overflow-hidden bg-coolGray h-screen">
      <div className="relative z-1">
        <div className="md:h-[7.5rem] h-[0px]" />
        <div className="flex items-center justify-center">
          <div className="max-w-[30rem] flex-1 bg-slateGray p-8 rounded-2xl mx-2 md:mx-0">
            <h4 className="text-36 font-domine text-center text-white">Reset Password</h4>
            <p className="text-lightIceBlue font-sans text-center text-18">Enter your email to reset your password</p>
            <div className="h-[2rem]" />
            <Input onChange={(e) => setEmail(e.target.value)} name={'email'} label="Your Email" error={submitError} />
            <div className="h-[1rem]" />
            <ButtonWithLoader
              onClick={() => dispatch(SEND_RESET_PASSWORD_EMAIL({ email }))}
              label="Send Reset Instructions"
              isLoading={isLoading}
            />
            <div className="h-[1rem]" />
            <p className="text-12 font-sans text-lightIceBlue text-center">
              Remember your password?{' '}
              <Link className="underline" to="/">
                Sign In
              </Link>
            </p>
          </div>
        </div>
        <div className="md:h-[7.5rem] h-[0px]" />
      </div>
      <EmailSentModal
        isOpen={showResetPasswordEmailModal}
        email={email}
        toggleModal={() => dispatch(SET_SHOW_RESET_PASSWORD_EMAIL_MODAL(false))}
      />
    </div>
  )
}

export default ResetPasswordScreen
